(() => {
  "use strict";

  const DATA = window.JAMR_DATA;
  const AR_SUMMARIES = window.JAMR_AR_SUMMARIES || {};
  const CART = window.JAMR_CART || {};
  const ANALYTICS = window.JAMR_ANALYTICS || {
    track() {}, screen() {}, results() {}, selectProduct() {}, viewProduct() {}, addToCart() {},
  };
  const SHOP_URL = window.JAMR_SHOP.root;
  const OWNER_PASSWORD_HASH = "PREVIEW_OWNER_CONTROLS_DISABLED";
  const app = document.getElementById("app");
  const adminModal = document.getElementById("admin-modal");
  const adminPassword = document.getElementById("admin-password");
  const adminError = document.getElementById("admin-error");
  const adminUnlock = document.getElementById("admin-unlock");
  const adminControls = document.getElementById("admin-controls");
  const adminClose = document.getElementById("admin-close");

  const state = {
    screen: "language",
    lang: "en",
    selected: [],
    moment: null,
    intensity: null,
    result: [],
    detail: null,
    previousScreen: null,
  };

  const copy = {
    en: {
      welcomeEyebrow: "WELCOME TO THE HOUSE OF JAMR AL OUD",
      welcomeTitle: "Discover the fragrance that belongs to you.",
      welcomeBody: "A private journey through instinct, memory and presence. Three decisions reveal three Jamr Al Oud signatures selected for you.",
      begin: "BEGIN YOUR FRAGRANCE JOURNEY",
      notesTitle: "What draws you in?",
      notesSub: "Choose from one to four ingredients. Only your selections can open the next step.",
      selected: "SELECTED",
      continue: "CONTINUE",
      momentTitle: "When should your fragrance speak?",
      momentSub: "Choose one moment to continue.",
      intensityTitle: "How strong should your presence be?",
      intensitySub: "Choose one level to reveal your three fragrances.",
      resultEyebrow: "YOUR JAMR AL OUD SELECTION",
      resultTitle: "Three signatures, selected for you.",
      primary: "MAIN",
      secondary: "SECONDARY",
      restart: "START A NEW TEST",
      back: "BACK",
      details: "VIEW PORTRAIT",
      profile: "SCENT DIRECTION",
      addToCart: "ADD TO BAG",
      soldOut: "VIEW PRODUCT",
      returnStore: "RETURN TO STORE",
    },
    ar: {
      welcomeEyebrow: "مرحباً بك في دار جمر العود",
      welcomeTitle: "اكتشف العطر الذي ينتمي إليك",
      welcomeBody: "رحلة خاصة عبر الإحساس والذاكرة والحضور. ثلاثة اختيارات تكشف ثلاثة عطور من جمر العود اختيرت لك.",
      begin: "ابدأ رحلتك العطرية",
      notesTitle: "ما المكونات التي تجذبك؟",
      notesSub: "اختر من مكوّن واحد إلى أربعة. لن تفتح الخطوة التالية قبل اختيارك.",
      selected: "تم الاختيار",
      continue: "متابعة",
      momentTitle: "متى تريد لعطرك أن يتحدث؟",
      momentSub: "اختر لحظة واحدة للمتابعة.",
      intensityTitle: "كيف تريد أن يكون حضورك؟",
      intensitySub: "اختر مستوى واحداً لتظهر عطورك الثلاثة.",
      resultEyebrow: "اختياراتك من جمر العود",
      resultTitle: "ثلاثة عطور اختيرت لك",
      primary: "الرئيسي",
      secondary: "الفرعي",
      restart: "ابدأ اختباراً جديداً",
      back: "رجوع",
      details: "اكتشف العطر",
      profile: "اتجاهك العطري",
      addToCart: "إضافة إلى السلة",
      soldOut: "عرض العطر",
      returnStore: "العودة إلى المتجر",
    },
  };

  let idleTimer = null;
  let brandHoldTimer = null;

  const t = key => copy[state.lang][key];
  const localized = object => object[state.lang] || object.en;
  const localizedSummary = product => window.JAMR_I18N.summary(product);
  const productDisplayImage = product => window.JAMR_I18N.asset(`assets/product-notes/${product.id}.jpg`);
  const storeUrl = product => `${SHOP_URL}products/${CART[product.id].handle}`;
  const purchaseLabel = product => CART[product.id].available ? t("addToCart") : t("soldOut");

  function purchaseControl(product, source, detail = false) {
    const extraClass = detail ? " detail-cart" : "";
    if (!CART[product.id].available) {
      return `<a class="cart-add${extraClass} sold-out-link" data-product-link="${product.id}" data-cart-source="${source}" href="${storeUrl(product)}">${purchaseLabel(product)}</a>`;
    }
    return `
      <form class="cart-add-form${detail ? " detail-cart-form" : ""}" data-cart-form="${product.id}" data-cart-source="${source}" action="${SHOP_URL}cart/add" method="post" accept-charset="UTF-8">
        <input type="hidden" name="form_type" value="product">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="id" value="${CART[product.id].variantId}">
        <input type="hidden" name="quantity" value="1">
        <input type="hidden" name="return_to" value="${SHOP_URL}cart">
        <button class="cart-add${extraClass}" type="submit">${purchaseLabel(product)}</button>
      </form>`;
  }

  function bindPurchaseControls() {
    app.querySelectorAll("[data-cart-form]").forEach(form => {
      form.addEventListener("submit", () => {
        const product = DATA.products.find(item => item.id === form.dataset.cartForm);
        ANALYTICS.addToCart(product, form.dataset.cartSource);
      });
    });
    app.querySelectorAll("[data-product-link]").forEach(link => {
      link.addEventListener("click", () => {
        const product = DATA.products.find(item => item.id === link.dataset.productLink);
        ANALYTICS.track("quiz_product_open", {
          product_id: product.id,
          product_name: product.title,
          source: link.dataset.cartSource,
          availability: "sold_out",
        });
      });
    });
  }

  function topbar(step = "") {
    return `
      <header class="topbar">
        <button class="brand-lock" id="brand-lock" aria-label="Jamr Al Oud">
          <span class="brand-name">JAMR AL OUD</span>
          <span class="brand-signature">THE HOUSE OF JAMR AL OUD &nbsp;|&nbsp; CRAFTED FOR KINGS</span>
        </button>
        <span class="step">${step}</span>
      </header>`;
  }

  function setLanguage(lang) {
    state.lang = lang;
    ANALYTICS.track("quiz_language_select", { language: lang });
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    state.screen = "welcome";
    render();
  }

  function resetJourney(toLanguage = false) {
    ANALYTICS.track("quiz_restart", {
      language: state.lang,
      restart_destination: toLanguage ? "language" : "welcome",
    });
    window.ScentV3.journey?.reset();
    state.selected = [];
    state.moment = null;
    state.intensity = null;
    state.result = [];
    state.detail = null;
    state.previousScreen = null;
    state.screen = toLanguage ? "language" : "welcome";
    render();
  }

  function resetIdleTimer() {
    clearTimeout(idleTimer);
    /* Private preview: never erase a visitor's work on an idle timer. */
  }

  function profileForSelection() {
    let winner = DATA.profiles[0];
    let best = -1;
    for (const profile of DATA.profiles) {
      const score = state.selected.reduce((sum, note) => sum + (profile.weights[note] || 0), 0);
      if (score > best) {
        best = score;
        winner = profile;
      }
    }
    return winner;
  }

  function intensityNumber(key) {
    return { subtle: 1, distinctive: 2, unforgettable: 3 }[key] || 2;
  }

  function recommendations() {
    const selectedNotes = [...new Set(state.selected)];
    const moment = DATA.moments.find(item => item.key === state.moment);
    const desiredIntensity = intensityNumber(state.intensity);

    return DATA.products.map(product => {
      const matchedNotes = selectedNotes.filter(note => product.catalogNoteKeys?.includes(note));
      let score = 22 - Math.abs(product.intensity - desiredIntensity) * 13;
      for (const keyword of moment.keywords) {
        if (product.searchText.includes(keyword)) score += 3.2;
      }
      return { ...product, matchedNotes, matchCount: matchedNotes.length, score };
    }).sort((a, b) => b.matchCount - a.matchCount || b.score - a.score || a.title.localeCompare(b.title)).slice(0, 3);
  }

  function renderLanguage() {
    app.innerHTML = `
      <section class="screen language-screen">
        <button class="crest" id="brand-lock" aria-label="Jamr Al Oud">J</button>
        <h1>THE SCENT CONCIERGE</h1>
        <p class="byline">BY JAMR AL OUD</p>
        <div class="language-actions">
          <button class="language-btn" data-lang="en">ENGLISH</button>
          <button class="language-btn" data-lang="ar">العربية</button>
        </div>
      </section>`;
    app.querySelectorAll("[data-lang]").forEach(button => {
      button.addEventListener("click", () => setLanguage(button.dataset.lang));
    });
  }

  function renderWelcome() {
    const rtl = state.lang === "ar" ? " rtl" : "";
    app.innerHTML = `
      <section class="screen welcome-screen${rtl}">
        ${topbar(state.lang === "en" ? "WELCOME" : "الترحيب")}
        <div class="hero">
          <div class="hero-copy">
            <p class="eyebrow">${t("welcomeEyebrow")}</p>
            <h1>${t("welcomeTitle")}</h1>
            <p>${t("welcomeBody")}</p>
            <button class="primary" id="begin">${t("begin")}</button>
          </div>
        </div>
      </section>`;
    document.getElementById("begin").addEventListener("click", () => {
      ANALYTICS.track("quiz_start", { language: state.lang });
      state.screen = "ingredients";
      render();
    });
  }

  function renderIngredients() {
    const rtl = state.lang === "ar" ? " rtl" : "";
    app.innerHTML = `
      <section class="screen${rtl}">
        ${topbar(state.lang === "en" ? "STEP 01 / NOTES" : "الخطوة ١ / المكونات")}
        <div class="content-head">
          <h1 class="section-title">${t("notesTitle")}</h1>
          <p class="section-subtitle">${t("notesSub")}</p>
        </div>
        <div class="ingredient-grid">
          ${DATA.ingredients.map(note => {
            const isSelected = state.selected.includes(note.key);
            return `
              <button class="ingredient-card${isSelected ? " selected" : ""}" data-note="${note.key}" aria-pressed="${isSelected}">
                <img src="${note.image}" alt="">
                <span class="ingredient-label">
                  <strong>${state.lang === "ar" ? note.ar : note.en}</strong>
                </span>
                <span class="select-mark">${isSelected ? "✓" : "+"}</span>
              </button>`;
          }).join("")}
        </div>
        <div class="bottom-bar">
          <button class="secondary" id="notes-back">${t("back")}</button>
          <span class="selection-count">${t("selected")}: ${state.selected.length} / 4</span>
          <button class="primary" id="notes-continue" ${state.selected.length ? "" : "disabled"}>${t("continue")}</button>
        </div>
      </section>`;

    app.querySelectorAll("[data-note]").forEach(button => {
      button.addEventListener("click", () => {
        const note = button.dataset.note;
        let action = "remove";
        if (state.selected.includes(note)) {
          state.selected = state.selected.filter(item => item !== note);
        } else if (state.selected.length < 4) {
          action = "add";
          state.selected.push(note);
        } else {
          return;
        }
        ANALYTICS.track("quiz_ingredient_toggle", {
          language: state.lang,
          ingredient: note,
          selection_action: action,
          selected_count: state.selected.length,
        });
        if(window.ScentV3.enabled())window.ScentV3.updateNotes(state);else render();
      });
    });
    document.getElementById("notes-back").addEventListener("click", () => {
      state.screen = "welcome";
      render();
    });
    document.getElementById("notes-continue").addEventListener("click", () => {
      if (!state.selected.length) return;
      state.selected.forEach((ingredient, index) => {
        const note = DATA.ingredientByKey[ingredient];
        ANALYTICS.track("quiz_ingredient_selected", {
          language: state.lang,
          ingredient,
          ingredient_name_en: note.en,
          ingredient_name_ar: note.ar,
          selection_position: index + 1,
          selected_ingredient_count: state.selected.length,
          scent_profile: profileForSelection().key,
        });
      });
      ANALYTICS.track("quiz_notes_complete", {
        language: state.lang,
        selected_ingredients: state.selected.join("|"),
        selected_ingredient_count: state.selected.length,
      });
      state.screen = "moment";
      render();
    });
  }

  function renderMoment() {
    const rtl = state.lang === "ar" ? " rtl" : "";
    app.innerHTML = `
      <section class="screen${rtl}">
        ${topbar(state.lang === "en" ? "STEP 02 / YOUR MOMENT" : "الخطوة ٢ / لحظتك")}
        <div class="content-head">
          <h1 class="section-title">${t("momentTitle")}</h1>
          <p class="section-subtitle">${t("momentSub")}</p>
        </div>
        <div class="choice-grid moments">
          ${DATA.moments.map(moment => `
            <button class="choice-card" data-moment="${moment.key}">
              <img src="${moment.image}" alt="">
              <span class="choice-copy">
                <strong>${localized(moment.label)}</strong>
                <small>${localized(moment.description)}</small>
              </span>
            </button>`).join("")}
        </div>
        <div class="bottom-bar">
          <button class="secondary" id="moment-back">${t("back")}</button>
          <span class="selection-count">${t("profile")}: ${localized(profileForSelection().label)}</span>
          <span></span>
        </div>
      </section>`;
    app.querySelectorAll("[data-moment]").forEach(button => {
      button.addEventListener("click", () => {
        state.moment = button.dataset.moment;
        ANALYTICS.track("quiz_moment_select", {
          language: state.lang,
          selected_moment: state.moment,
        });
        state.screen = "intensity";
        render();
      });
    });
    document.getElementById("moment-back").addEventListener("click", () => {
      state.screen = "ingredients";
      render();
    });
  }

  function renderIntensity() {
    const rtl = state.lang === "ar" ? " rtl" : "";
    app.innerHTML = `
      <section class="screen${rtl}">
        ${topbar(state.lang === "en" ? "STEP 03 / PRESENCE" : "الخطوة ٣ / الحضور")}
        <div class="content-head">
          <h1 class="section-title">${t("intensityTitle")}</h1>
          <p class="section-subtitle">${t("intensitySub")}</p>
        </div>
        <div class="choice-grid intensities">
          ${DATA.intensities.map((level, index) => `
            <button class="choice-card" data-intensity="${level.key}">
              <span class="level-visual"><span class="level-ring" style="--level:${index + 1}">${index + 1}</span></span>
              <span class="choice-copy">
                <strong>${localized(level.label)}</strong>
                <small>${localized(level.description)}</small>
              </span>
            </button>`).join("")}
        </div>
        <div class="bottom-bar">
          <button class="secondary" id="intensity-back">${t("back")}</button>
          <span class="selection-count">${localized(DATA.moments.find(item => item.key === state.moment).label)}</span>
          <span></span>
        </div>
      </section>`;
    app.querySelectorAll("[data-intensity]").forEach(button => {
      button.addEventListener("click", () => {
        state.intensity = button.dataset.intensity;
        state.result = recommendations();
        ANALYTICS.track("quiz_intensity_select", {
          language: state.lang,
          selected_intensity: state.intensity,
        });
        ANALYTICS.track("quiz_complete", {
          language: state.lang,
          scent_profile: profileForSelection().key,
          selected_ingredients: state.selected.join("|"),
          selected_ingredient_count: state.selected.length,
          selected_moment: state.moment,
          selected_intensity: state.intensity,
          recommended_products: state.result.map(product => product.id).join("|"),
        });
        state.screen = "result";
        render();
      });
    });
    document.getElementById("intensity-back").addEventListener("click", () => {
      state.screen = "moment";
      render();
    });
  }

  function productCard(product, rank) {
    const primary = DATA.ingredientByKey[product.displayPrimary || product.primary];
    const secondary = DATA.ingredientByKey[product.displaySecondary || product.secondary];
    const primaryName = state.lang === "ar" ? primary.ar : primary.en.toUpperCase();
    const secondaryName = state.lang === "ar" ? secondary.ar : secondary.en.toUpperCase();
    return `
      <article class="product-card" data-product="${product.id}">
        <button class="product-open">
          <span class="product-image-wrap"><img src="${productDisplayImage(product)}" alt="${window.JAMR_I18N.title(product)}"></span>
          <span class="product-info">
            <span class="product-rank">0${rank} &nbsp; ${t("details")}</span>
            <h3>${window.JAMR_I18N.title(product)}</h3>
            <span class="note-pair">${t("primary")}: ${primaryName} &nbsp;|&nbsp; ${t("secondary")}: ${secondaryName}</span>
          </span>
        </button>
        ${purchaseControl(product, "results")}
      </article>`;
  }

  function renderResult() {
    const rtl = state.lang === "ar" ? " rtl" : "";
    const profile = profileForSelection();
    app.innerHTML = `
      <section class="screen${rtl}">
        ${topbar(state.lang === "en" ? "YOUR SELECTION" : "اختياراتك")}
        <div class="content-head">
          <p class="eyebrow">${t("resultEyebrow")}</p>
          <h1 class="section-title">${t("resultTitle")}</h1>
          <p class="section-subtitle">${t("profile")}: ${localized(profile.label)}</p>
        </div>
        <div class="result-grid">
          ${state.result.map((product, index) => productCard(product, index + 1)).join("")}
        </div>
        <div class="result-bottom">
          <a class="secondary store-link" href="${SHOP_URL}">${t("returnStore")}</a>
          <button class="primary" id="result-restart">${t("restart")}</button>
        </div>
      </section>`;
    ANALYTICS.results({
      language: state.lang,
      profile: profile.key,
      ingredients: state.selected,
      moment: state.moment,
      intensity: state.intensity,
      products: state.result,
    });
    app.querySelectorAll("[data-product]").forEach(card => {
      card.addEventListener("click", event => {
        const product = DATA.products.find(item => item.id === card.dataset.product);
        if (event.target.closest(".cart-add")) {
          return;
        }
        ANALYTICS.selectProduct(product, state.result.findIndex(item => item.id === product.id) + 1);
        state.detail = product;
        state.previousScreen = "result";
        state.screen = "detail";
        render();
      });
    });
    bindPurchaseControls();
    app.querySelector(".store-link").addEventListener("click", () => {
      ANALYTICS.track("return_to_store", {
        language: state.lang,
        source: "results",
      });
    });
    document.getElementById("result-restart").addEventListener("click", () => resetJourney(false));
  }

  function renderDetail() {
    const product = state.detail;
    const primary = DATA.ingredientByKey[product.displayPrimary || product.primary];
    const secondary = DATA.ingredientByKey[product.displaySecondary || product.secondary];
    const rtl = state.lang === "ar" ? " rtl" : "";
    app.innerHTML = `
      <section class="screen${rtl}">
        ${topbar(state.lang === "en" ? "OLFACTORY PORTRAIT" : "البصمة العطرية")}
        <div class="detail-layout">
          <div class="detail-image"><img src="${productDisplayImage(product)}" alt="${window.JAMR_I18N.title(product)}"></div>
          <div class="detail-copy">
            <p class="eyebrow">${state.lang === "ar" ? "دار جمر العود" : "THE HOUSE OF JAMR AL OUD"}</p>
            <h1>${window.JAMR_I18N.title(product)}</h1>
            <div class="detail-pairs">
              <span>${t("primary")}: <strong>${state.lang === "ar" ? primary.ar : primary.en}</strong></span>
              <span>${t("secondary")}: <strong>${state.lang === "ar" ? secondary.ar : secondary.en}</strong></span>
            </div>
            <p>${localizedSummary(product)}</p>
            <div class="detail-actions">
              <button class="secondary" id="detail-back">${t("back")}</button>
              ${purchaseControl(product, "product_detail", true)}
            </div>
          </div>
        </div>
      </section>`;
    ANALYTICS.viewProduct(product);
    document.getElementById("detail-back").addEventListener("click", () => {
      state.screen = state.previousScreen || "result";
      render();
    });
    bindPurchaseControls();
  }

  function bindBrandLock() {
    const brand = document.getElementById("brand-lock");
    if (!brand) return;
    const start = event => {
      event.preventDefault();
      clearTimeout(brandHoldTimer);
      brandHoldTimer = setTimeout(openAdmin, 2200);
    };
    const cancel = () => clearTimeout(brandHoldTimer);
    brand.addEventListener("pointerdown", start);
    brand.addEventListener("pointerup", cancel);
    brand.addEventListener("pointercancel", cancel);
    brand.addEventListener("pointerleave", cancel);
  }

  function render() {
    state.lang=window.JAMR_I18N.locale;
    if (window.ScentV3.transition?.(state, render)) return;
    resetIdleTimer();
    const renderers = {
      language: renderLanguage,
      welcome: renderWelcome,
      ingredients: renderIngredients,
      moment: renderMoment,
      intensity: renderIntensity,
      result: renderResult,
      detail: renderDetail,
    };
    if (!window.ScentV3.before(state)) renderers[state.screen]();
    window.ScentV3.after(state);
    ANALYTICS.screen(state.screen, state.lang);
    window.JAMR_I18N.afterRender(state);
  }

  function openAdmin() {
    adminModal.hidden = false;
    adminPassword.value = "";
    adminError.hidden = true;
    adminControls.hidden = true;
    adminUnlock.hidden = false;
    setTimeout(() => adminPassword.focus(), 100);
  }

  function closeAdmin() {
    adminModal.hidden = true;
    adminPassword.value = "";
    adminControls.hidden = true;
    adminUnlock.hidden = false;
  }

  async function sha256(text) {
    if (window.crypto && window.crypto.subtle) {
      const bytes = new TextEncoder().encode(text);
      const digest = await window.crypto.subtle.digest("SHA-256", bytes);
      return Array.from(new Uint8Array(digest)).map(byte => byte.toString(16).padStart(2, "0")).join("");
    }
    return "";
  }

  adminUnlock.addEventListener("click", async () => {
    const digest = await sha256(adminPassword.value);
    if (digest !== OWNER_PASSWORD_HASH) {
      adminError.hidden = false;
      adminPassword.value = "";
      adminPassword.focus();
      return;
    }
    adminError.hidden = true;
    adminUnlock.hidden = true;
    adminPassword.hidden = true;
    adminControls.hidden = false;
  });

  adminClose.addEventListener("click", () => {
    adminPassword.hidden = false;
    closeAdmin();
  });
  document.getElementById("admin-reset").addEventListener("click", () => {
    adminPassword.hidden = false;
    closeAdmin();
    resetJourney(false);
  });
  document.getElementById("admin-language").addEventListener("click", () => {
    adminPassword.hidden = false;
    closeAdmin();
    resetJourney(true);
  });

          document.addEventListener("pointerdown", resetIdleTimer, { passive: true });

  window.JAMR_BRIDGE = {state, copy, data:DATA, cart:CART, render, topbar, reset:resetJourney, recommendations, profileForSelection, setLanguage, go(screen){state.screen=screen;render();}};
  state.lang=window.JAMR_I18N.locale;state.screen="welcome";document.documentElement.lang=state.lang;document.documentElement.dir=state.lang==="ar"?"rtl":"ltr";
  render();
})();
